"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProgramAddress = void 0;
// Copyright © 2022 LIFINITY FOUNDATION All Rights Reserved.
const getProgramAddress = () => {
    return 'EewxydAPCCVuNEyrVN68PuSYdQ7wKn27V9Gjeoi8dy3S';
};
exports.getProgramAddress = getProgramAddress;
